import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Page, Text, Loading, Layout, Button } from '@shopify/polaris';
import 'regenerator-runtime/runtime';
import CryptoJS from 'crypto-js';

const OrderDetail = () => {
  const { id } = useParams();
  const host = new URLSearchParams(location.search).get('host');
  const shop = new URLSearchParams(location.search).get('shop');
  const [isLoading, setIsLoading] = useState(false);
  const [order, setOrder] = useState({});
  const [shopifyData, setShopifyData] = useState({});
  const [tracking, setTracking] = useState({});
  const [decryptedToken, setDecryptedToken] = useState({});

  const decryptToken = (finalToken) => {
    // Generar la clave de cifrado de la misma manera que el backend
    
    
  
    try {
      // Decodificar el token Base64
      const decodedToken = atob(finalToken);
      
  
      // Separar datos cifrados e IV
      
  
      
  
      // Separar el texto desencriptado en email y token
      const [senduAuthEmail, senduAuthToken] = decodedToken.split("@@@");
      if (!senduAuthEmail || !senduAuthToken) {
        console.error("El texto desencriptado no contiene los datos esperados.");
        return null;
      }
  
      
  
      return { senduAuthEmail, senduAuthToken };
    } catch (error) {
      console.error("Error durante la desencriptación:", error.message);
      return null;
    }
  };
  
  
  useEffect(() => {
    setIsLoading(true);
    window
      .fetch(
        `${process.env.REACT_APP_BASEURL}/order-detail/${id}?shop=${shop}&&host=${host}`,
        {
          method: 'GET',
        }
      )
      .then((response) => response.json())
      .then((resp) => {
        console.log('json')
        console.log(resp);
        setOrder(resp.order);
        setShopifyData(resp.shopify);
        setTracking(resp.tracking);
        console.log(resp.order.tk)
        // Desencriptar el token recibido desde el backend
        if (resp.order.tk) {
          
          const decrypted = decryptToken(resp.order.tk);
          
          setDecryptedToken(decrypted);
        }

        setIsLoading(false);
      })
      .catch(function err() {
        setIsLoading(false);
      });
  }, []);

  const fetchLabelUrl = async () => {
    const maxAttempts = 6;
    let attempts = 0;
  
    while (attempts < maxAttempts) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASEURL}/order-api/${order?.response_sendu}/${order?.number_order}?shop=${shop}&host=${host}`,
          { method: 'GET' }
        );
        const labelUrl = await response.text(); // El backend devuelve texto directamente
  
        if (labelUrl && !labelUrl.startsWith("Error")) {
          return labelUrl;
        }
  
        attempts++;
        await new Promise((resolve) => setTimeout(resolve, 1000)); // Esperar 1 segundo antes de reintentar
      } catch (error) {
        console.error("Error al obtener la etiqueta:", error);
      }
    }
  
    throw new Error("No se pudo obtener la etiqueta después de múltiples intentos.");
  };

  const handlePrintLabel = async () => {
    setIsLoading(true);
  
    try {
      let labelUrl = await fetchLabelUrl();
      setIsLoading(false);
  
      if (labelUrl) {
        // Limpiar la URL
        labelUrl = labelUrl.replace(/\\/g, ""); // Remover caracteres de escape (\)
        labelUrl = labelUrl.replace(/["]+/g, ""); // Remover comillas adicionales
  
        // Normalizar las barras en la URL
        const urlParts = labelUrl.split("://");
        if (urlParts.length === 2) {
          const protocol = urlParts[0];
          const path = urlParts[1].replace(/\/{2,}/g, "/"); // Reemplazar barras dobles en la ruta
          labelUrl = `${protocol}://${path}`;
        }
  
        console.log("URL limpia:", labelUrl); // Para verificar la salida
        window.open(labelUrl, '_blank', 'noopener,noreferrer');
      } else {
        console.error("No se pudo obtener la URL del label después de múltiples intentos.");
        alert("No se pudo obtener la URL del label. Por favor, inténtalo de nuevo más tarde.");
      }
    } catch (error) {
      console.error("Error al obtener la etiqueta:", error);
      setIsLoading(false);
      alert("Ocurrió un error al obtener la etiqueta. Por favor, inténtalo de nuevo más tarde.");
    }
  };
  
  
  
  

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <Page
          breadcrumbs={[
            {
              content: 'Órdenes',
              url: `/orders/?shop=${shop}&&host=${host}`,
            },
          ]}
          title="Detalle de Orden"
        >
          <Card title="Información de Envío">
            <Card.Section title="Número de Envío Sendu - #SP">
              <Text>{order?.number_order}</Text>
            </Card.Section>
            <Card.Section title="Nombre de Cliente">
              <Text>{shopifyData?.shipping_address?.name} </Text>
            </Card.Section>
            <Card.Section title="Teléfono de Cliente">
              <Text>{shopifyData?.shipping_address?.phone} </Text>
            </Card.Section>
            <Card.Section title="Email de Cliente">
              <Text>{tracking?.email} </Text>
            </Card.Section>
            <Card.Section title="Entrega">
              <p>{order?.forma_entrega} </p>
            </Card.Section>
            <Card.Section title="Información de Envío">
              <Text>Peso: {tracking?.weight}</Text>
              <Text>Altura: {tracking?.height}</Text>
              <Text>Longitud: {tracking?.large}</Text>
              <Text>Profundidad: {tracking?.deep}</Text>
            </Card.Section>
            <Card.Section title="Fecha estimada de entrega">
              <p>{order?.transit_days}</p>
            </Card.Section>
            <Card.Section title="Imprimir etiqueta">
              <Button primary onClick={handlePrintLabel}>
                Imprimir Etiqueta
              </Button>
            </Card.Section>
          </Card>
        </Page>
      )}
    </>
  );
};

export default OrderDetail;
